import React, { useEffect } from 'react'
import { Col, Form, Button, Alert, Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import settingsStore from './store'
import { Provider, inject, observer } from 'mobx-react'
import LoadingSpinner from 'Components/LoadingSpinner'
import useTitle from 'hooks/useTitle'

const Settings = inject('settingsStore')(observer(({ settingsStore }) => {
    const { t } = useTranslation()
    const title = t('company_settings')
    useTitle(title)

    useEffect(() => {
        settingsStore.loadSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (settingsStore.isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            {settingsStore.saveError && (
                <Alert variant="danger">{t(settingsStore.saveError)}</Alert>
            )}
            {settingsStore.saveMessage && (
                <Alert variant="success">{t(settingsStore.saveMessage)}</Alert>
            )}

            <Card className="mb-4">
                <Card.Header>{t('fiscal_alert_settings')}</Card.Header>
                <Card.Body>
                    <p className="text-muted small">{t('fiscal_alert_settings_hint')}</p>
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault()
                            settingsStore.saveFiscalAlerts()
                        }}
                    >
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="switch"
                                id="fiscal-alerts-enabled"
                                label={t('fiscal_alerts_enabled')}
                                checked={settingsStore.fiscalAlerts.enabled}
                                onChange={(e) => settingsStore.setFiscalField('enabled', e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Row>
                            <Col md={6}>
                                <Form.Group controlId="fiscalAlertEmail" className="mb-3">
                                    <Form.Label>{t('fiscal_alert_email')}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={settingsStore.fiscalAlerts.email}
                                        onChange={(e) => settingsStore.setFiscalField('email', e.target.value)}
                                        placeholder={t('fiscal_alert_email_placeholder')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="fiscalAlertWhatsApp" className="mb-3">
                                    <Form.Label>{t('fiscal_alert_whatsapp')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        inputMode="tel"
                                        value={settingsStore.fiscalAlerts.whatsAppNumber}
                                        onChange={(e) => settingsStore.setFiscalField('whatsAppNumber', e.target.value)}
                                        placeholder="584121234567"
                                    />
                                    <Form.Text className="text-muted">{t('fiscal_alert_whatsapp_hint')}</Form.Text>
                                </Form.Group>
                            </Col>
                        </Form.Row>
                        <Form.Group controlId="fiscalAlertTelegram" className="mb-3">
                            <Form.Label>{t('fiscal_alert_telegram')}</Form.Label>
                            <Form.Control
                                type="text"
                                value={settingsStore.fiscalAlerts.telegramChatId}
                                onChange={(e) => settingsStore.setFiscalField('telegramChatId', e.target.value)}
                                placeholder={t('fiscal_alert_telegram_placeholder')}
                            />
                        </Form.Group>
                        <Button type="submit" disabled={settingsStore.isSaving}>
                            {settingsStore.isSaving ? t('saving') : t('save')}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
}))

export default (() => {
    return (
        <Provider settingsStore={settingsStore}><Settings /></Provider>
    )
})
